import React from 'react';

export const StageStarIcon = ({ filled = false }: { filled?: boolean }) => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill={filled ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

interface StageActionsProps {
  index: number;
  total: number;
  showSetFinished: boolean;
  axis?: 'vertical' | 'horizontal';
  onReorder: (direction: 'up' | 'down') => void;
  onDelete: () => void;
  onSetFinished: () => void;
}

const StageActions: React.FC<StageActionsProps> = ({
  index,
  total,
  showSetFinished,
  axis = 'vertical',
  onReorder,
  onDelete,
  onSetFinished
}) => (
  <div className="stage-actions" onClick={(e) => e.stopPropagation()}>
    <button
      type="button"
      className="stage-icon-btn stage-move-btn"
      disabled={index === 0}
      onClick={() => onReorder('up')}
      aria-label={axis === 'horizontal' ? 'Move stage left' : 'Move stage up'}
      title={axis === 'horizontal' ? 'Move left' : 'Move up'}
    >
      {axis === 'horizontal' ? (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M15 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ) : (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M5 15l7-7 7 7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
    </button>
    <button
      type="button"
      className="stage-icon-btn stage-move-btn"
      disabled={index === total - 1}
      onClick={() => onReorder('down')}
      aria-label={axis === 'horizontal' ? 'Move stage right' : 'Move stage down'}
      title={axis === 'horizontal' ? 'Move right' : 'Move down'}
    >
      {axis === 'horizontal' ? (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M9 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ) : (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M19 9l-7 7-7-7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
    </button>
    {showSetFinished && (
      <button
        type="button"
        className="stage-icon-btn stage-star-btn"
        onClick={onSetFinished}
        aria-label="Mark as finished stage"
        title="Mark as finished stage"
      >
        <StageStarIcon />
      </button>
    )}
    <button
      type="button"
      className="stage-icon-btn"
      onClick={onDelete}
      aria-label="Delete stage"
      title="Delete stage"
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  </div>
);

export default StageActions;
